import "./TotalYearCard.scss";
import { formatFloatNumber } from "../../../utils/format";

const TotalYearCard = ({ title, amount }) => {
  return (
    <div className="frame-card">
      <div>
        <div className="frame-icon-title">
          <p>{`${title}`}</p>
        </div>
        <p className="frame-amount">${formatFloatNumber(amount)}</p>
      </div>
    </div>
  );
};

export default TotalYearCard;
